import { z } from 'zod'
import type { RuralReportTemplateProps } from '../../report/ruralReportTemplateTitle'

export const requirementReportTypeSchema = z.enum([
  'soilUseDeclaration',
  'acknowledgmentTerm',
  'verificationTerm',
  'celescDeclaration',
])

export type RequirementReportType = z.infer<typeof requirementReportTypeSchema>

export interface RequirementReportProps extends RuralReportTemplateProps {
  type: RequirementReportType
}

export const requirementReportColor = '#00A859'

export const requirementReportTitleMap: Record<RequirementReportType, string> = {
  soilUseDeclaration: 'Declaração de uso e ocupação de solo',
  acknowledgmentTerm: 'Termo de ciência',
  verificationTerm: 'Termo de verificação',
  celescDeclaration: 'Declaração para CELESC',
}

const requirementReportFileBaseNameMap: Record<RequirementReportType, string> = {
  soilUseDeclaration: 'declaracao-uso-ocupacao-solo',
  acknowledgmentTerm: 'termo-ciencia',
  verificationTerm: 'termo-verificacao',
  celescDeclaration: 'declaracao-celesc',
}

export function buildRequirementReportFileBaseName(type: RequirementReportType) {
  return requirementReportFileBaseNameMap[type]
}
